import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-x-3" }
const _hoisted_2 = { class: "space-y-2" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = { class: "flex flex-col h-full border-r ct-border-2" }
const _hoisted_5 = { class: "flex-shrink-0 flex items-center space-x-2 px-6 h-[64px] border-b ct-border-2" }
const _hoisted_6 = { class: "ct-text-1 text-lg lg:text-xl flex items-center justify-between w-full" }
const _hoisted_7 = { class: "flex flex-col h-full overflow-y-auto" }

import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm, ButtonCloseXs } from "@easy/ui/buttons";
import { CardToggle } from "@easy/ui/cards";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { computed, ref } from "vue";
import SectionCard from "./SectionCard.vue";
import AddBlock from "./block/AddBlock.vue";
import { useBlocks } from "@/apps/page/services/blocks/useBlocks";
import { useSections } from "@/apps/page/services/useSections";
import { useDragState } from "@/shared/utils/useDragState";
import AddToolList from "@/apps/page/project/sidebar/sections/tool/AddToolList.vue";


import { SectionBlockType } from "@/apps/page/page.interfaces";
import { InPageUsedTools } from "@/apps/page/page-project.interface";

// TODO @Jabi: simplify this interface? or extract it if needed ?
interface SectionSelection {
    title: string;
    icon: object;
    tool?: InPageUsedTools;
    type?: SectionBlockType;
    createTitle?: string;
    emptyTitle?: string;
    emptySubtitle?: string;
    count?: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AddSection',
  props: {
    toolProjects: {
        type: Object,
        default: () => ({}),
    },
},
  emits: ["back"],
  setup(__props, { emit: __emit }) {



const emit = __emit;
const currentSection = ref<SectionSelection | undefined>(undefined);

const { getAllBlockTypes, blocks } = useBlocks();
const { getAllSectionTypes } = useSections();

// TODO: @Jabi: for now show only existing blocks (count > 0)
const allBlockTypes = computed(() => getAllBlockTypes().filter((block) => block.count > 0));
const allSectionTypes = computed(() => getAllSectionTypes());

const goBack = () => {
    emit("back");
};

const { isDragging, startDragging, resetDragState } = useDragState();

const openSection = (section: SectionSelection) => {
    resetDragState();
    currentSection.value = section;
};

function handleDragStart() {
    startDragging();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PageSidebar), null, {
    sidebarTitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ButtonSecondaryIconSm), { onClick: goBack }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeftIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("page.sections.add_section")), 1)
      ])
    ]),
    sidebarMain: _withCtx(() => [
      _createVNode(_unref(CardToggle), {
        title: _ctx.$t('page.sections.standard_sections')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allBlockTypes.value, (section) => {
              return (_openBlock(), _createBlock(SectionCard, {
                key: section.type,
                section: section,
                active: currentSection.value,
                onOpen: openSection
              }, null, 8, ["section", "active"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_unref(CardToggle), {
        title: _ctx.$t('page.sections.app_sections')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSectionTypes.value, (section) => {
              return (_openBlock(), _createBlock(SectionCard, {
                key: section.title,
                section: section,
                active: currentSection.value,
                onOpen: openSection,
                tool: section.tool
              }, null, 8, ["section", "active", "tool"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute inset-0 lg:!left-[320px] lg:w-[320px] top-0 z-20 ct-bg-1", { '-translate-x-[9999px]': _unref(isDragging) || !currentSection.value }]),
        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (currentSection.value = undefined))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(currentSection.value?.title), 1),
              _createVNode(_unref(ButtonCloseXs), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (currentSection.value = undefined))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!currentSection.value?.tool)
              ? (_openBlock(), _createBlock(AddBlock, {
                  key: 0,
                  blocks: _unref(blocks),
                  "current-section": currentSection.value,
                  onDragStart: handleDragStart
                }, null, 8, ["blocks", "current-section"]))
              : _createCommentVNode("", true),
            (currentSection.value?.tool)
              ? (_openBlock(), _createBlock(AddToolList, {
                  key: 1,
                  projects: __props.toolProjects[currentSection.value?.tool],
                  tool: currentSection.value?.tool,
                  onDragStart: _cache[1] || (_cache[1] = ($event: any) => (_unref(startDragging)()))
                }, null, 8, ["projects", "tool"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 34)
    ]),
    _: 1
  }))
}
}

})